import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Body } from "capitalrx-components-2.0/lib/typography";
import styles from "./styles.module.scss";

/**
 * The `SharedDropdownPlaceholder` component properties.
 */

export interface SharedDropdownPlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `SharedDropdown` component.
 */
export const SharedDropdownPlaceholder: FC<SharedDropdownPlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.PlaceholderDropdown, "shared-dropdown", "placeholder"],
    testIdPrefix: "shared-dropdown",
  });

  return (
    <Body {...getBasePropsFromHtmlProps(baseHtmlProps)} size="small">
      <Skeleton />
    </Body>
  );
};
